import http from "../../helpers/http";

import {
  FETCH_TRAFFIK_AND_SEX_CONTENT_SUCCESS,
  FETCH_TRAFFIK_AND_SEX_CONTENT_FAILED
} from "../actions/actionTypes";

export const fetchData = () => (dispatch) => {
  http
    .get("traffik-and-sex")
    .then(({ data }) => {
      dispatch({
        type: FETCH_TRAFFIK_AND_SEX_CONTENT_SUCCESS,
        payload: data
      });
    })
    .catch((error) => {
      dispatch({
        type: FETCH_TRAFFIK_AND_SEX_CONTENT_FAILED,
        payload: error
      });
    });
};
